export class DiseasesModel {
    constructor(
        public id: string = '',
        public name: string = '',
        public vector: string = '',
        public symptoms: string = '',
        public isHaveVaccine: any
    ) {
			this.id = id;
			this.name = name;
			this.vector = vector;
      this.symptoms = symptoms;
      this.isHaveVaccine = isHaveVaccine;
		 }
}

export class DiseaseModel {
    constructor(
        public id: string = '',
        public name: string = '',
        public vector: string = '',
        public symptoms: string = '',
        public diseaseMap: string = '',
        public generalInformation: string = '',
        public isHaveVaccine: any = 0,
    ) {
			this.id = id;
			this.name = name;
			this.vector = vector;
			this.symptoms = symptoms;
			this.diseaseMap = diseaseMap;
      this.generalInformation = generalInformation;
      this.isHaveVaccine = isHaveVaccine;
		 }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/master-data/diseases.model.ts